import React, { Component } from 'react'
import HomeTodayPage from '../components/HomeToday/HomeTodayPage';

class HomeToday extends Component {

    // constructor(props) {
    //     super(props);
    // }

    componentDidMount() {
        window.addEventListener('load', function () {
            window.history.pushState({}, '')
        });
    }

    render() {

        return (
            <div>
                <HomeTodayPage />
            </div>
        )
    }
}

export default HomeToday